export class BreadcrumbViewModel {

    title: string;              // Title to display
    link: string;               // Link to redirect
    is_active: boolean;         // To display active title

    constructor(title: string, link: string, is_active?: boolean) {
        this.title = title;
        this.link = link;
        this.is_active = is_active != null ? is_active : false;
    }

}
